import {ChatEngine} from "react-chat-engine";
import "./App.css";
import LoginForm from "./components/LoginForm";
import ChatFeed from "./components/ChatFeed.jsx";

const App = () =>{
    //if you are not logged in
    if(!localStorage.getItem("username")) return <LoginForm />

   return ( <ChatEngine 
             height = "100vh"
             projectID = "fffb4d64-c2e4-4670-83ae-c2335ac73416"
             userName = {localStorage.getItem("username")}
             userSecret = {localStorage.getItem("password")}
             renderChatFeed = {(chatAppProps) => <ChatFeed {...chatAppProps} />}
    />
   )
}
export default App;